import { PlusCircle, Menu, BarChart3 } from "lucide-react";
import { HintDot, HintTooltip } from "../tour/GuidedTour";
import { HINT_DOT_IDS } from "../../lib/navigation";
import { trackEvent } from "../../lib/track";

export const Sidebar = ({
  sidebarOpen,
  setSidebarOpen,
  navGroups,
  activeTab,
  setActiveTab,
  activeGalaxy,
  setActiveGalaxy,
  setShowLanding,
}) => {
  return (
    <aside className={`fixed left-0 top-0 h-full bg-card border-r border-border transition-all duration-300 z-40 ${sidebarOpen ? 'w-64' : 'w-0 md:w-16'} overflow-hidden`}>
      <div className="p-4 border-b border-border flex items-center justify-between">
        {sidebarOpen && (
          <div className="flex items-center gap-2">
            <BarChart3 className="w-6 h-6 text-primary" />
            <span className="font-bold text-lg">AIOO</span>
          </div>
        )}
        <button onClick={() => setSidebarOpen(!sidebarOpen)} className="p-2 hover:bg-muted rounded-lg" data-testid="sidebar-toggle">
          <Menu className="w-5 h-5" />
        </button>
      </div>
      
      <nav className="p-3 space-y-1 overflow-y-auto" style={{ maxHeight: "calc(100vh - 64px - 80px)" }}>
        {navGroups.map((group, gi) => (
          <div key={gi}>
            {group.label && sidebarOpen && (
              <p className="text-[10px] font-bold text-muted-foreground/50 uppercase tracking-[0.15em] px-3 pt-3 pb-1">{group.label}</p>
            )}
            {group.label && !sidebarOpen && gi > 0 && (
              <div className="mx-3 my-2 border-t border-border/30" />
            )}
            {group.items.map(item => (
              <HintTooltip key={`hint-${item.id}`} id={item.id}>
              <button
                key={item.id}
                onClick={() => {
                  if (item.soon || item.current) return;
                  if (item.homepage) {
                    sessionStorage.removeItem("aioo_entered");
                    setShowLanding(true);
                    trackEvent("nav_homepage", activeGalaxy);
                  } else if (item.galaxy) {
                    setActiveGalaxy(item.galaxy);
                    trackEvent("switch_galaxy", item.galaxy);
                  } else {
                    setActiveTab(item.id);
                    trackEvent("nav_tab", activeGalaxy, item.id);
                    try {
                      const hints = JSON.parse(localStorage.getItem("aioo_hints") || "{}");
                      hints[item.id] = true;
                      localStorage.setItem("aioo_hints", JSON.stringify(hints));
                    } catch {}
                  }
                }}
                data-testid={`nav-${item.id}`}
                className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${
                  item.soon
                    ? 'text-muted-foreground/40 cursor-default'
                    : item.current
                      ? 'bg-primary/10 text-primary border border-primary/20 cursor-default'
                      : activeTab === item.id 
                        ? 'bg-primary text-primary-foreground' 
                        : 'hover:bg-muted text-muted-foreground hover:text-foreground'
                }`}
              >
                <item.icon className="w-4.5 h-4.5 flex-shrink-0" />
                {sidebarOpen && (
                  <span className="text-sm font-medium flex items-center gap-2 flex-1">
                    {item.label}
                    {item.soon && <span className="text-[8px] px-1.5 py-0.5 rounded-full bg-white/[0.04] border border-white/[0.06] text-slate-500 uppercase tracking-wider font-bold">Soon</span>}
                  </span>
                )}
                {sidebarOpen && !item.soon && !item.current && !item.homepage && !item.galaxy && activeTab !== item.id && HINT_DOT_IDS.includes(item.id) && (
                  <HintDot id={item.id} />
                )}
              </button>
              </HintTooltip>
            ))}
          </div>
        ))}
      </nav>

      {sidebarOpen && (
        <div className="absolute bottom-4 left-4 right-4">
          <p className="text-[10px] text-muted-foreground text-center mb-2">Don't see your app listed?</p>
          <button
            onClick={() => setActiveTab("contribute")}
            data-testid="sidebar-submit-app-btn"
            className="w-full flex items-center justify-center gap-2 px-3 py-2 bg-primary/15 hover:bg-primary/25 border border-primary/30 rounded-lg text-sm text-primary font-medium transition-colors"
          >
            <PlusCircle className="w-4 h-4" />
            Submit App
          </button>
        </div>
      )}
    </aside>
  );
};
